import { render, staticRenderFns } from "./levelOneMenu.vue?vue&type=template&id=ae4a98b6&scoped=true"
import script from "./levelOneMenu.vue?vue&type=script&lang=js"
export * from "./levelOneMenu.vue?vue&type=script&lang=js"
import style0 from "./levelOneMenu.vue?vue&type=style&index=0&id=ae4a98b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a98b6",
  null
  
)

export default component.exports